export class ResetPasswordRequest {
  username!: string;
  newPassword!: string;
  confirmPassword!: string;

  constructor() {
  }
}
